export const DEFAULT_SIZE = '2x';
export const SIZES = ['2x', 'xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl'] as const;

export const separator = ' ';
